import { render, staticRenderFns } from "./InformasiUmum.vue?vue&type=template&id=3ad490f1&"
import script from "./InformasiUmum.vue?vue&type=script&lang=js&"
export * from "./InformasiUmum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports